import React from 'react';
import { useTranslation } from 'react-i18next';

type Level = string;
type Variant = 'default' | 'secondary';

const levelStyles: Record<Variant, Record<Level, string>> = {
  default: {
    HIGH: 'text-white bg-[#E50C0CE5]',
    MEDIUM: 'text-white bg-[#FBC774]',
    LOW: 'text-white bg-[#75B4DB]',
  },
  secondary: {
    HIGH: 'text-[#008418] bg-[#00841826]',
    MEDIUM: 'text-orange_dark_2 bg-orange_light_2',
    LOW: 'text-red_dark bg-[#E50C0C26]',
  },
};

/* const BadgeLevel = ({ level }: { level: string }) => {
  const { t } = useTranslation('app');
  const shardClassNames = 'py-1 px-1.5x rounded-[8px]';
  const highClassNames = `${shardClassNames} text-caption text-white bg-[#E50C0CE5]`;
  const mediumClassNames = `${shardClassNames} text-caption text-white bg-[#FBC774]`;
  const lowClassNames = `${shardClassNames} text-caption text-white bg-[#75B4DB]`;

  return (
    <p
      className={
        {
          HIGH: highClassNames,
          MEDIUM: mediumClassNames,
          LOW: lowClassNames,
        }[level] || lowClassNames
      }
    >
      {t(level)}
    </p>
  );
};

export default BadgeLevel;
 */

const BadgeLevel = ({
  level,
  variant = 'default',
}: {
  level: Level;
  variant?: Variant;
}) => {
  const { t } = useTranslation('app');

  const baseClasses = 'py-1 px-1.5 rounded-[8px] text-caption';

  return (
    <p className={`${baseClasses} ${levelStyles[variant][level]}`}>
      {t(level)}
    </p>
  );
};

export default BadgeLevel;
